import React, { useEffect } from 'react';
import { LoadChild } from 'ui-component/motion/load';
import { useStyles } from './index.style';

interface IHookProps {
  children: any;
  title?: string | React.ReactElement;
  noMotion?: boolean;
  right?: any;
  contentFill?: boolean;
  [propName: string]: any;
}

const CMP: React.FC<IHookProps> = ({ children, title, noMotion, contentFill, right, ...props }) => {
  const { styles, cx } = useStyles({ fill: !!contentFill, hasTitle: !!title });

  const content = (
    <div className={cx(styles.container, styles.fillContainer)} {...props}>
      {title ? (
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          {right ? right : null}
        </div>
      ) : null}
      <div className={cx(styles.fill)}>{children}</div>
    </div>
  );
  if (noMotion) {
    return content;
  }
  return (
    <LoadChild {...props} className={cx(styles.warp, props.className)}>
      {content}
    </LoadChild>
  );
};

export default CMP;
